var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5111 44.5905C10.3144 44.5905 0.427734 34.7038 0.427734 22.5072C0.427734 10.3105 10.3144 0.423828 22.5111 0.423828C34.7077 0.423828 44.5944 10.3105 44.5944 22.5072C44.5944 34.7038 34.7077 44.5905 22.5111 44.5905ZM22.5111 40.1738C27.1966 40.1738 31.6901 38.3125 35.0033 34.9994C38.3164 31.6862 40.1777 27.1926 40.1777 22.5072C40.1777 17.8217 38.3164 13.3281 35.0033 10.0149C31.6901 6.7018 27.1966 4.84049 22.5111 4.84049C17.8256 4.84049 13.332 6.7018 10.0188 10.0149C6.7057 13.3281 4.8444 17.8217 4.8444 22.5072C4.8444 27.1926 6.7057 31.6862 10.0188 34.9994C13.332 38.3125 17.8256 40.1738 22.5111 40.1738ZM11.4694 24.7155H31.3444V29.1322H22.5111V35.7572L11.4694 24.7155ZM22.5111 15.8822V9.25716L33.5527 20.2988H13.6777V15.8822H22.5111Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveExchange);
export default __webpack_public_path__ + "static/media/activeExchange.f7a0502bb5c309617be533650f417c50.svg";
export { ForwardRef as ReactComponent };